import React from 'react'
import { MenuItem, TextField, FormControl } from '@material-ui/core'

function SelectField({
   fieldInvalid,
   formValue,
   handleChange,
   fieldLabel,
   fieldName,
   error,
   items,
   ...otherProps
}) {
   return (
      <FormControl fullWidth>
         <TextField
            select
            error={fieldInvalid}
            value={formValue}
            onChange={handleChange}
            label={fieldLabel}
            name={fieldName}
            helperText={fieldInvalid && !formValue.length && error}
            variant="outlined"
            size="small"
            margin="normal"
            {...otherProps}
         >
            {items?.map(item => (
               <MenuItem key={item.value} value={item.value} style={{ whiteSpace: 'normal' }}>
                  {item.label}
               </MenuItem>
            ))}
         </TextField>
      </FormControl>
   )
}

export default SelectField
